import React from 'react';

const Logo = ({ className = "w-8 h-8", showText = true }) => {
  return (
    <div className="flex items-center gap-3">
      <img
        src="/logo.png"
        alt="Aether Logo"
        className={`${className} object-contain drop-shadow-[0_0_8px_rgba(200,200,200,0.4)]`}
        style={{ filter: 'drop-shadow(0 0 6px rgba(220,220,220,0.35))' }}
      />
      {showText && (
        <span
          className="text-xl tracking-[0.25em] uppercase font-light text-white hover:text-white/80 transition-colors"
          style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '0.25em' }}
        >
          Aether
        </span>
      )}
    </div>
  );
};

export default Logo;
